import { useEffect, useState } from 'react'
import { useDeepCompareMemoize } from 'use-deep-compare-effect'

interface UseDebounceOptions {
  comparison?: 'shallow' | 'deep'
}

export function useDebounce<T>(
  value: T,
  delayMs: number,
  { comparison = 'shallow' }: UseDebounceOptions = {}
) {
  const [debouncedValue, setDebouncedValue] = useState(value)
  const deepDependencyValue = useDeepCompareMemoize<T>(
    comparison === 'deep' ? value : (undefined as T)
  )
  const dependencyValue = comparison === 'deep' ? deepDependencyValue : value

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(dependencyValue)
    }, delayMs)

    return () => {
      clearTimeout(handler)
    }
  }, [comparison, dependencyValue, delayMs])

  return debouncedValue
}
